<template>
  <el-dialog
    width="50rem"
    top="2vh"
    :center="true"
    :show-close="false"
    :close-on-click-modal="true"
    :visible.sync="showProfileDialog"
    :append-to-body="true"
  >
    <div slot="title" class="profile-title">
      <span class="profile-controls">
        <el-tooltip :content="showBlacklisted ? 'Hide Blacklisted' : 'Show Blacklisted'">
          <el-button
            type="text"
            @click="showBlacklisted = !showBlacklisted"
            icon="fa fa-ban"
            :style="showBlacklisted ? 'color: white;' : ''"
          />
        </el-tooltip>
        <el-tooltip :content="showDeleted ? 'Hide Removed' : 'Show Removed'">
          <el-button
            type="text"
            @click="showDeleted = !showDeleted"
            icon="fa fa-trash-o"
            :style="showDeleted ? 'color: white;' : ''"
          />
        </el-tooltip>
      </span>
      <div class="avatar-container">
        <img
          class="avatar-image"
          :src="showFallbackProfileImage ? identicon : profileImage"
          @error="profileImageError"
        />
      </div>
      <span>{{ profileName }}</span>
    </div>

    <el-tabs v-model="activeTab" :stretch="true" style="width: 48rem; margin: auto -15px">
      <el-tab-pane label="Demographics" name="personal">
        <table>
          <tbody>
            <tr v-for="(content, category) in appendProfileFields(profile)" :key="category">
              <span
                v-if="
                  !excludeCategories.find(x => x === category) &&
                    appendProfileFields(profile) &&
                    showCategory(appendProfileFields(profile))
                "
              >
                <!-- <h3 class="category-title">{{capitalise(category)}}</h3> -->
                <td v-for="(fields, key) in content" :key="key" style="display: table-row;">
                  <ProfileDetailFieldItem
                    v-if="!excludeProps.find(x => x === key)"
                    :key="`${category}-${key}`"
                    :fieldKey="getKey(key)"
                    :category="category"
                    :fields="filteredFields(fields)"
                    :profileId="profileId"
                    @removeNugget="handleRemoveNugget"
                    @blacklistNugget="handleBlacklistNugget"
                    @onShowProfileMap="handleShowProfileMap"
                  />

                  <div v-if="key === 'location' && showProfileMap" class="mapouter">
                    <div class="gmap_canvas">
                      <iframe
                        id="gmap_canvas"
                        class="map_frame"
                        :src="`https://maps.google.com/maps?q=${location}&z=10&output=embed`"
                        frameborder="0"
                        scrolling="no"
                        marginheight="0"
                        marginwidth="0"
                      />
                      <a href="https://www.embedgooglemap.net"></a>
                    </div>
                  </div>
                </td>
              </span>
            </tr>
          </tbody>
        </table>
        <!-- <div v-for="(fields, key) in content" :key="key">
     
        </div>-->
      </el-tab-pane>

      <!-- <el-tab-pane label="Location" name="location" :disabled="!location" :lazy="true">
        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe
              id="gmap_canvas"
              class="map_frame"
              :src="`https://maps.google.com/maps?q=${location}&z=10&output=embed`"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            />
            <a href="https://www.embedgooglemap.net"></a>
          </div>
        </div>
      </el-tab-pane>-->

      <el-tab-pane label="Interactions" name="interactions">
        <loader
          message="Loading interactions"
          v-if="loadingInteractions[panelSettings.uuid] && !interactions(panelSettings.uuid).length"
        ></loader>
        <interactions-filter
          @onFilterInteractions="handleFilterInteractions"
          :interactions="groupByInterationChannel(interactions(panelSettings.uuid))"
          :profile="profile"
        />
        <message-panel
          :id="panelSettings.uuid"
          :polling="false"
          :title="'Message history'"
          :type="'profile'"
          :color="'#ee2465'"
          :canClose="false"
          :hasSettings="false"
          :interactions="filterByChannelType(interactions(panelSettings.uuid))"
          :hasSearch="false"
          :isFixedPanel="true"
          :loadingSuccess="!!loadingInteractionsSuccess[panelSettings.uuid] || false"
          :loading="loadingInteractions[panelSettings.uuid] || false"
          :hasMoreInteractions="panelHasMoreInteractions(panelSettings.uuid) || false"
          @loadMore="handleLoadMore"
          v-if="!loadingInteractions[panelSettings.uuid]"
        />
      </el-tab-pane>
      <el-tab-pane label="Campaigns &amp; Surveys" name="Surveys">
        <loader
          message="Loading Campaigns &amp; Surveys"
          v-if="loadingInteractions[panelSettings.uuid] && !interactions(panelSettings.uuid).length"
        ></loader>

        <el-table
          v-if="!loadingInteractions[panelSettings.uuid]"
          style="width: 100%; font-size: 13px;"
          :data="formatCampaignSurveysData()"
        >
          <el-table-column sortable label="Title" prop="title"></el-table-column>
          <el-table-column sortable label="Type" prop="type"></el-table-column>
          <el-table-column sortable label="Date" prop="startDate"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <div slot="footer" class="dialog-footer">
      <el-button @click="showProfileDialog = false">Close</el-button>
    </div>
  </el-dialog>
</template>

<script>
import gql from 'graphql-tag';
import collect from 'collect.js';
import { mapGetters, mapState } from 'vuex';
import ProfileDetailFieldItem from '@/components/profile/ProfileDetailFieldItem';
import MessagePanel from '@/components/interaction/MessagePanel';
import Loader from '@/components/common/Loader';
import InteractionsFilter from '@/components/interaction/InteractionsFilter';
import * as dashboardTypes from '@/store/modules/interaction/mutation-types';
import {
  getDataItem,
  getProfileIdenticon,
  getProfileItemValue,
  getPrimaryIdentifier,
  getAgeFromYear,
  profileCampaignDateFormat,
} from './profileUtils';

export default {
  name: 'ProfileDetailDialog',
  components: { ProfileDetailFieldItem, MessagePanel, Loader, InteractionsFilter },

  props: {
    profileDialogVisible: {
      type: Boolean,
      required: true,
    },
    originalProfile: {
      type: Object,
      default: () => ({}),
    },
    campaignSurveys: {
      type: Array,
      default: () => [],
    },
    campaignId: {
      type: Number,
      default: 0,
    },
    profileId: {
      type: String,
      required: true,
    },
    updatedProfileMap: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    excludeCategories: ['_id', 'id', '__typename', 'meta'],
    excludeProps: ['profile_image', 'name'],
    showFallbackProfileImage: false,
    activeTab: 'personal',
    showBlacklisted: false,
    showDeleted: false,
    filteredChannelKeys: [],
    showProfileMap: false,
  }),

  mounted() {
    this.$store.commit(`interaction/${dashboardTypes.ADD_MANUAL_PANEL}`, this.panelSettings);
    this.$store.dispatch('interaction/fetchProfileInteractions', [
      this.panelSettings.uuid,
      this.profileId,
      this.campaignId,
    ]);
  },

  destroyed() {
    this.$store.commit(`interaction/${dashboardTypes.REMOVE_MANUAL_PANEL}`, this.panelSettings);
    this.$store.dispatch('interaction/stopPollPanelInteractions', this.panelSettings.uuid);
    this.$store.dispatch('interaction/cleanUpDashboardIntervals');
  },

  computed: {
    ...mapGetters('interaction', ['interactions']),
    ...mapState('interaction', [
      'loadingInteractions',
      'hasMoreInteractions',
      'loadingInteractionsSuccess',
    ]),
    ...mapState('profile', ['profileFilters']),
    showProfileDialog: {
      get() {
        return this.profileDialogVisible;
      },
      set(val) {
        this.$emit('onDialogVisibilityChange', val);
      },

      profileImage() {},
    },

    panelSettings() {
      return {
        uuid: `profile-panel-${this.panelId}`,
        type: 'profile',
        settings: {
          name: 'Recent Messages',
          campaign_ids: [this.id],
        },
      };
    },

    panelId() {
      const length = 5;
      return Math.round(36 ** (length + 1) - Math.random() * 36 ** length)
        .toString(36)
        .slice(1);
    },

    profile() {
      return this.updatedProfileMap[this.profileId] || this.originalProfile;
    },

    profileImage() {
      return getDataItem(this.profile, 'personal', 'profile_image', this.identicon);
    },

    identicon() {
      return getProfileIdenticon(this.profile);
    },

    profileName() {
      return getProfileItemValue(
        getDataItem(this.profile, 'personal', 'name', getPrimaryIdentifier(this.profile)),
      );
    },
    location() {
      return getProfileItemValue(getDataItem(this.profile, 'demographics', 'location', ''))
        .split('s')
        .join('+');
    },
  },

  methods: {
    handleShowProfileMap() {
      this.showProfileMap = !this.showProfileMap;
    },
    filteredFields(fields) {
      const fieldsList = Array.isArray(fields) ? [...fields] : [fields];
      if (this.showBlacklisted && this.showDeleted) return [...fieldsList];
      return [...fieldsList].filter(x => {
        let show = true;
        if (x.blacklisted !== undefined && !this.showBlacklisted) show = x.blacklisted !== true;
        if (x.deleted !== undefined && !this.showDeleted) show = x.deleted !== true;
        return show;
      });
    },
    appendProfileFields(profile) {
      const { age } = this.formatAgeGroup(profile);
      if (age.length) {
        return { ...profile, age_index: this.formatAgeGroup(profile) };
      }

      return { ...profile, age_index: this.formatAgeGroup(profile) };
    },

    formatAgeGroup(profile) {
      const { meta } = profile;
      const ageIndex = collect(meta).get('age_index');

      if (ageIndex) {
        return {
          age: [
            {
              value: getAgeFromYear(ageIndex),
              score: 1,
              comfirmations: 2,
            },
          ],
        };
      }
      return { age: [] };
    },
    formatCampaignSurveysData() {
      const { campaign } = this.profile.meta;
      const profileCampaign = collect(this.getProfileCampaigns(campaign))
        .map(item => item.value)
        .all();

      const campaignCollection = collect(this.campaignSurveys)
        .map(item => ({
          ...item.campaign,
          id: Number(item.campaign.id),
          type: this.formatFieldName(item.type),
          startDate: profileCampaignDateFormat(item.startDate),
        }))
        .whereIn('id', profileCampaign)
        .all();

      return campaignCollection;
    },
    showCategory(category) {
      return Object.keys(category).reduce(this.hasAllowedFields, false);
    },

    getKey(key) {
      return key;
    },

    getStyleClass(key) {
      return key % 2 === 0;
    },

    getProfileCampaigns(campaign) {
      return Array.isArray(campaign) ? campaign : [{ ...campaign }];
    },
    handleRemoveNugget(cfg) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($filter: RemoveNuggetInput!) {
              removeNuggetValue(filter: $filter) {
                id
                identifiers
                interests
                personal
                demographics
              }
            }
          `,
          variables: { filter: cfg },
          client: 'apiv2',
        })
        .then(resp => {
          this.$emit('profileUpdated', resp.data.removeNuggetValue);
        })
        .catch(console.log); // eslint-disable-line
    },

    handleBlacklistNugget(cfg) {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($filter: BlacklistNuggetInput!) {
              blacklistNuggetValue(filter: $filter) {
                id
                identifiers
                interests
                personal
                demographics
              }
            }
          `,
          variables: { filter: cfg },
          client: 'apiv2',
        })
        .then(resp => {
          this.$emit('profileUpdated', resp.data.blacklistNuggetValue);
        })
        .catch(console.log); // eslint-disable-line
    },
    handleFilterInteractions(channelKeys) {
      this.filteredChannelKeys = channelKeys;
    },
    filterByChannelType(interactions) {
      const filteredInteractions = collect(interactions)
        .whereIn('channel', this.filteredChannelKeys)
        .all();

      return filteredInteractions.length ? filteredInteractions : interactions;
    },
    panelHasMoreInteractions(panelId) {
      return this.hasMoreInteractions[panelId] !== undefined
        ? this.hasMoreInteractions[panelId]
        : true;
    },

    filterBySurvey(intercations) {
      return intercations.filter(interaction => interaction.channel === 'survey');
    },

    groupByInterationChannel(interactions) {
      return collect(interactions)
        .groupBy('channel')
        .all();
    },

    handleLoadMore() {
      this.$store.dispatch('interaction/fetchNextPageProfileInteractions', [
        this.panelSettings.uuid,
        this.profileId,
        this.campaignId,
      ]);
    },

    capitalise(content) {
      return content
        .split(' ')
        .map(x => `${x[0].toUpperCase()}${x.slice(1)}`)
        .join(' ');
    },

    formatFieldName(text) {
      const transformText = txt => `${txt[0].toUpperCase()}${txt.slice(1)}`.replace('_', ' ');
      if (text) {
        return transformText(text);
      }
      return 'other';
    },

    hasAllowedFields(acc = false, fieldKey) {
      /**
       * Reducer function used to determine if a category has any alowed fields.
       * Allowed fields is not in the excludeProps data property.
       */
      if (acc) return true; // short circuit if allowed field was found.
      if (!this.excludeProps.find(x => x === fieldKey)) {
        return true;
      }
      return acc;
    },
    profileImageError() {
      this.showFallbackProfileImage = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

$profile-banner: lighten($violent-violet, 2%);
.category-title {
  font-size: 1.3em;
  text-align: center;
}

.profile-title {
  margin: -20px;
  padding: 10px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  background-color: $profile-banner;
  color: white;
  font-size: 1.5em;
  font-weight: bold;
}

.avatar-container {
  margin-bottom: 13px;
  background-color: $profile-banner;
  width: 100%;
  display: block;
}

.avatar-image {
  border-radius: 25%;
  border: 2px solid white;
  width: 150px;
  height: 150px;
  display: block;
  margin: 13px auto;
}

$striped-color: rgb(240, 240, 240);

@mixin stripe-color-items {
  @for $i from 1 through 20 {
    .profile-field-item-#{$i} {
      background-color: $striped-color;
    }
  }
}

@include stripe-color-items;

.mapouter {
  text-align: right;
  margin: 0;
  transition: 0.5s all;
}
.gmap_canvas {
  overflow: hidden;
  background: none !important;
  margin: 0;
}
.map_frame {
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// ProfileDetailDialog.vue?e89679c6